const paths = {
  app: {
    root: {
      path: '',
      getHref: () => '',
    },
    users: {
      path: 'user-management',
      getHref: () => '/user-management',
    },
    // logs: {
    //   path: 'logs',
    //   getHref: () => '/logs',
    // },
    // businessUnits: {
    //   path: 'businessUnits',
    //   getHref: () => '/businessUnits',
    // },
    // locations: {
    //   path: 'locations',
    //   getHref: () => '/locations',
    // },
    // partTypes: {
    //   path: 'part-types',
    //   getHref: () => '/part-types',
    // },
    //     admin: {
    //       root: {
    //         path: 'admin',
    //         getHref: () => '/admin',
    //       },
    //       dashboard: {
    //         path: '',
    //         getHref: () => '/admin',
    //       },

    //       productionStart: {
    //         root: {
    //           path: 'productionStart',
    //           getHref: () => '/admin/productionStart',
    //         },
    //         tab: {
    //           path: ':menuId',
    //           getHref: (menuId: string) => `/admin/productionStart/${menuId}`,
    //         },
    //       },
    //       parts: {
    //         root: {
    //           path: 'parts',
    //           getHref: () => '/admin/parts',
    //         },
    //       },
    //       ssnEditor: {
    //         root: {
    //           path: 'ssnEditor',
    //           getHref: () => '/admin/ssnEditor',
    //         },
    //       },
    //       woEditor: {
    //         root: {
    //           path: 'woEditor',
    //           getHref: () => '/admin/woEditor',
    //         },
    //       },
    //       stationEditor: {
    //         root: {
    //           path: 'stationEditor',
    //           getHref: () => '/admin/stationEditor',
    //         },
    //       },
    //       productionLineEditor: {
    //         root: {
    //           path: 'productionLineEditor',
    //           getHref: () => '/admin/productionLineEditor',
    //         },
    //       },
    //       processCreator: {
    //         root: {
    //           path: 'processCreator',
    //           getHref: () => '/admin/processCreator',
    //         },
    //       },
    //       processes: {
    //         root: {
    //           path: 'processes',
    //           getHref: () => '/admin/processes',
    //         },

    //         process: {
    //           root: {
    //             path: ':key',
    //             getHref: (key: string) => `/admin/processes/${key}`,
    //           },
    //           edit: {
    //             path: 'edit',
    //             getHref: (key: string) => `/admin/processes/${key}/edit`,
    //           },
    //         },
    //       },
    //       templateCreator: {
    //         root: {
    //           path: 'templateCreator',
    //           getHref: () => '/admin/templateCreator',
    //         },
    //       },
    //       templates: {
    //         root: {
    //           path: 'templates',
    //           getHref: () => '/admin/templates',
    //         },
    //         template: {
    //           root: {
    //             path: ':key?',
    //             getHref: (key?: string) => (key ? `/admin/templates/${key}` : '/admin/templates/new'),
    //           },
    //           edit: {
    //             path: 'edit',
    //             getHref: (key?: string) => (key ? `/admin/templates/${key}/edit` : '/admin/templates/new/edit'),
    //           },
    //         },
    //       },
    //       deviceCreator: {
    //         root: {
    //           path: 'deviceCreator',
    //           getHref: () => '/admin/deviceCreator',
    //         },
    //       },
    //       actionConfig: {
    //         root: {
    //           path: 'actionConfig',
    //           getHref: () => '/admin/actionConfig',
    //         },
    //       },
    //     },
    //     client: {
    //       root: {
    //         path: 'client',
    //         getHref: () => '/client',
    //       },
    //       assembly: {
    //         path: 'assembly',
    //         getHref: () => '/client/assembly',
    //       },
    //       quality1: {
    //         path: 'qualityChecklist',
    //         getHref: () => '/client/qualityChecklist',
    //       },
    //     },
  },
} as const

export { paths }
